import { BaseReactiveClass } from 'Classes/BaseReactiveClass';

export class ModelAccountBeneficialOwnerItem extends BaseReactiveClass {
  static TYPE_CONTROLLER = 'controller';
  static TYPE_BENEFICIAL_OWNER = 'beneficial owner';

  static STATUS_SUCCESS = 'success';
  static STATUS_PENDING = 'pending';

  constructor(data) {
    super(data);

    this.$set('$dataLoading', false);
  }

  get fullName() {
    return `${this.first_name} ${this.last_name}`;
  }

  get isStatusSuccess() {
    return this.status === ModelAccountBeneficialOwnerItem.STATUS_SUCCESS;
  }

  get isTypeController() {
    return this.type === ModelAccountBeneficialOwnerItem.TYPE_CONTROLLER;
  }

  get isTypeBeneficialOwner() {
    return this.type === ModelAccountBeneficialOwnerItem.TYPE_BENEFICIAL_OWNER;
  }

  get isNonUsCountry() {
    return this.country !== 'US';
  }
}
